import { useTranslation, Trans } from 'react-i18next';
import { CleanUrl } from "../../../utils/cleanUrl";

function PromotionPeriodNotification(props) {
    const { promotionSettings } = props;
    const { t } = useTranslation();
    const imagePath = CleanUrl(`${process.env.REACT_APP_BASE_URL}/${window.drupalDirectory}/`);

    const startTime = promotionSettings.promotion_page.participation_start_time;
    const endTime = promotionSettings.promotion_page.participation_end_time;

    return (
        <div className="pweu-promotion-period-notification">
            <img src={imagePath + "not-completed.svg"} alt="" />
            <h2>{t("Come back later.")}</h2>
            <p>
                <Trans i18nKey="timeFrameMessage">
                    Sorry - you are trying to participate outside of the time frame. The Promotion is online between <strong>{{ startTime }}</strong> and <strong>{{ endTime }}</strong>.
                </Trans>
            </p>
        </div>
    );
}

export default PromotionPeriodNotification;
